function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2917 0.125C23.1355 0.125 24.9093 0.85375 26.2142 2.16138C27.5204 3.46625 28.2505 5.22625 28.2505 7.06875V17.9312C28.2505 21.7675 25.1293 24.875 21.2917 24.875H7.70805C3.87042 24.875 0.750549 21.7675 0.750549 17.9312V7.06875C0.750549 3.2325 3.85667 0.125 7.70805 0.125H21.2917ZM23.4793 9.11748L23.5893 9.00748C23.9179 8.60873 23.9179 8.03123 23.5742 7.63248C23.383 7.42761 23.1204 7.30248 22.8468 7.27498C22.558 7.25986 22.283 7.35748 22.0754 7.54998L15.8755 12.5C15.078 13.1614 13.9354 13.1614 13.1255 12.5L6.93805 7.54998C6.51042 7.23373 5.91917 7.27498 5.56305 7.64623C5.1918 8.01748 5.15055 8.60873 5.46542 9.02123L5.64555 9.19998L11.9018 14.0812C12.6718 14.6862 13.6054 15.0162 14.583 15.0162C15.5579 15.0162 16.508 14.6862 17.2767 14.0812L23.4793 9.11748Z",
  fill: "#B6B6B6"
});

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.e90943b2.svg";
export { ForwardRef as ReactComponent };